<template>
    <div id="pdfvuer" class="color-dark">
       <!--  <div id="buttons" class="ui grey three item inverted bottom fixed menu transition" style="background: red">
            <a class="item" @click="page > 1 ? page-- : 1">
                <i class="left chevron icon"></i>
                Back
            </a>
            <a class="ui active item">
                {{page}} / {{ numPages ? numPages : '∞' }}
            </a>
            <a class="item" @click="page < numPages ? page++ : 1">
                Forward
                <i class="right chevron icon"></i>
            </a>
        </div>
        <div id="buttons" class="ui grey three item inverted bottom fixed menu transition" style="background: red">
            <a class="item" @click="scale -= scale > 0.2 ? 0.1 : 0">
                <i class="left chevron icon" />
                Zoom -
            </a>
            <a class="ui active item">
                {{ formattedZoom }} %
            </a>
            <a class="item" @click="scale += scale < 2 ? 0.1 : 0">
                Zoom +
                <i class="right chevron icon" />
            </a>
        </div> -->
        <pdf :src="pathView" v-for="i in pagesDocShow" :text="false" :key="i" :id="i" :page="i" :scale.sync="zoomData" style="width:100%;margin:0 auto 20px auto;">
            <template slot="loading" class="text-center">
                <b-spinner small type="grow" variant="dark" />
            </template>
        </pdf>
    </div>
</template>

<script>
    import pdfvuer from 'pdfvuer'
    import { APP_CONFIG } from '@/utils/constants'

    export default {
        name: 'PreviewPdf',
        components: {
            pdf: pdfvuer
        },
        props: {
            pathView: String,
            zoomData: Number
        },
        data () {
            return {
                page: 1,
                numPages: 0,
                errors: [],
                eachPage: 5,
                pagesDocShow: 0,
                isNotFile: false
                // scale: 'page-width'
            }
        },
        // computed: {
            // formattedZoom () {
            //     return Number.parseInt(this.scale * 100);
            // },
        // },
        mounted () {
            this.getPdf()
        },
        watch: {
            show: function (s) {
                if(s) {
                    this.getPdf();
                }
            },
            // page: function (p) {
            //     if( window.pageYOffset <= this.findPos(document.getElementById(p)) || ( document.getElementById(p+1) && window.pageYOffset >= this.findPos(document.getElementById(p+1)) )) {
            //         // window.scrollTo(0,this.findPos(document.getElementById(p)));
            //         document.getElementById(p).scrollIntoView();
            //     }
            // }
        },
        methods: {
            getPdf () {
                let self = this;
                let pdfdata = pdfvuer.createLoadingTask(`${self.pathView}`);
                pdfdata.then(pdf => {
                    self.numPages = pdf.numPages;
                    self.pagesDocShow = pdf.numPages > self.eachPage ? self.eachPage : pdf.numPages;
                    let contentViewer = document.getElementById('content_viewer')
                    contentViewer.onscroll = function() { 
                        changePage() 
                    }

                    function changePage () {
                        var i = 1, count = Number(pdf.numPages);
                        
                        do {
                            // if(window.pageYOffset >= self.findPos(document.getElementById(i)) && 
                            //     window.pageYOffset <= self.findPos(document.getElementById(i+1))) {
                            //     self.page = i
                            // }
                            if(contentViewer.scrollTop >= self.findPos(document.getElementById(i)) && 
                                contentViewer.scrollTop <= self.findPos(document.getElementById(i+1))) {
                                self.page = i
                            }
                            i++
                        } while ( i < count)
                        // if (window.pageYOffset >= self.findPos(document.getElementById(i))) {
                        //     self.page = i
                        // }
                        if (contentViewer.scrollTop >= self.findPos(document.getElementById(i))) {
                            self.page = i
                        }
                        if(self.page === (self.pagesDocShow - 2) && self.pagesDocShow < count) {
                            if( Number(self.pagesDocShow + self.eachPage) > count ) {
                                self.pagesDocShow = count;
                            } else {
                                self.pagesDocShow += self.eachPage;
                            }
                        }
                        // console.log('scroll: ', self.page, contentViewer.scrollTop, self.findPos(document.getElementById(i)))
                    }
                }).catch(() => {self.isNotFile = true});;
            },
            findPos(obj) {
                if(obj) {
                    return obj.offsetTop;
                }
            }
        }
    }
</script>

<style lang="css" scoped>
    #buttons {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    /* Page content */
    .content {
        padding: 16px;
    }
</style>